import React, { useState, useEffect } from 'react';
import { CONSTANTS } from './data';
import ReferralPage from './ReferralPage';
import LandingPage from './LandingPage';

function App() {
  const [utmParams, setUtmParams] = useState({});
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  
  // Extract UTM parameters from URL and update current path
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const extractedUtmParams = {};
    
    // Extract all UTM parameters from URL
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    
    utmKeys.forEach(key => {
      const value = urlParams.get(key);
      if (value) {
        extractedUtmParams[key] = value;
      }
    });
    
    setUtmParams(extractedUtmParams);
    
    // Set current path
    setCurrentPath(window.location.pathname);
    
    // Listen for route changes (like browser back button)
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };
    
    window.addEventListener('popstate', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  // Redirect to Typeform with email parameter and UTM parameters
  const redirectToTypeform = (emailAddress) => {
    // Encode the email for URL safety
    const encodedEmail = encodeURIComponent(emailAddress);
    
    // Start building the Typeform URL with the email parameter
    let typeformUrl = `https://rs1t5aakpfq.typeform.com/to/TD5lsavZ?email=${encodedEmail}`;
    
    // Add UTM parameters - first prioritize any that came from the original URL
    const finalUtmParams = {
      utm_source: utmParams.utm_source || CONSTANTS.UTM_PARAMS.SOURCE,
      utm_medium: utmParams.utm_medium || CONSTANTS.UTM_PARAMS.MEDIUM,
      utm_campaign: utmParams.utm_campaign || CONSTANTS.UTM_PARAMS.CAMPAIGN,
      utm_term: utmParams.utm_term || CONSTANTS.UTM_PARAMS.TERM,
      utm_content: utmParams.utm_content || CONSTANTS.UTM_PARAMS.CONTENT
    };
    
    // Append all UTM parameters to the URL
    Object.entries(finalUtmParams).forEach(([key, value]) => {
      if (value) {
        typeformUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    
    // Update state (optional, as we're redirecting)
    // setIsSubmitted(true);
    
    // Redirect to the Typeform
    window.location.href = typeformUrl;
  };

  // Check if we are on the referral page
  if (currentPath === '/referral') {
    return <ReferralPage />;
  }

  // Otherwise, show the landing page
  return <LandingPage redirectToTypeform={redirectToTypeform} />;
}

export default App;
